import { COLLECTIONS } from '../../constants/collections';
import { CONFIG_CATEGORIES } from '../../constants/systemConfig';
import { createDocument, getAllDocuments, updateDocument, deleteDocument } from './firestoreService';
import { doc, runTransaction } from 'firebase/firestore';
import { db } from '../../firebase/firebaseConfig';

// ============ NUMBER RANGE CONFIGS ============

// Create number range configuration
export const createNumberRangeConfig = async (configData) => {
    const data = {
        ...configData,
        category: CONFIG_CATEGORIES.NUMBER_RANGES,
        currentValue: configData.startValue || 0,
        isActive: true,
        createdAt: new Date(),
        updatedAt: new Date()
    };
    return await createDocument(COLLECTIONS.SYSTEM_CONFIGS, data);
};

// Get all number ranges
export const getNumberRanges = async (tenantId) => {
    const conditions = [
        { type: 'where', field: 'tenantId', operator: '==', value: tenantId },
        { type: 'where', field: 'category', operator: '==', value: CONFIG_CATEGORIES.NUMBER_RANGES }
    ];

    let results = await getAllDocuments(COLLECTIONS.SYSTEM_CONFIGS, conditions);
    // Sort
    return results.sort((a, b) => a.entityName.localeCompare(b.entityName));
};

// Update number range
export const updateNumberRangeConfig = async (configId, updates) => {
    const data = {
        ...updates,
        updatedAt: new Date()
    };
    return await updateDocument(COLLECTIONS.SYSTEM_CONFIGS, configId, data);
};

// Delete number range
export const deleteNumberRangeConfig = async (configId) => {
    return await deleteDocument(COLLECTIONS.SYSTEM_CONFIGS, configId);
};

// ============ SEQUENCE GENERATION ============

/**
 * Get next number for a specific entity (e.g., 'DOCK_TYPE', 'DOCK')
 * Uses Firestore Transaction to ensure atomic increment.
 * If range doesn't exist, returns null or throws.
 */
export const getNextSequenceNumber = async (tenantId, entityName) => {
    try {
        // 1. Find the config doc for this entity
        const conditions = [
            { type: 'where', field: 'tenantId', operator: '==', value: tenantId },
            { type: 'where', field: 'category', operator: '==', value: CONFIG_CATEGORIES.NUMBER_RANGES },
            { type: 'where', field: 'entityName', operator: '==', value: entityName }
        ];

        const configs = await getAllDocuments(COLLECTIONS.SYSTEM_CONFIGS, conditions);
        if (configs.length === 0) return null; // No range defined

        const rangeConfig = configs[0];
        const rangeDocRef = doc(db, COLLECTIONS.SYSTEM_CONFIGS, rangeConfig.id);

        let nextNumString = '';

        await runTransaction(db, async (transaction) => {
            const rangeDoc = await transaction.get(rangeDocRef);
            if (!rangeDoc.exists()) {
                throw "Document does not exist!";
            }

            const data = rangeDoc.data();
            const current = data.currentValue || (data.startValue - 1);
            const nextVal = current + 1;

            if (data.endValue && nextVal > data.endValue) {
                throw new Error("Number range exhausted");
            }

            transaction.update(rangeDocRef, { currentValue: nextVal, updatedAt: new Date() });

            // Format: Prefix + Number
            // e.g. "DT-" + "1001"
            nextNumString = (data.prefix || '') + nextVal;
        });

        return nextNumString;

    } catch (e) {
        console.error("Sequence Error:", e);
        throw e;
    }
};
